<template>
    <div class="item_tag_add_form">
        <div>
            <div v-for="(error, error_key) in errors">
                <div v-for="(message,key) in error">
                    <Message severity="error">{{ error_key }}:{{ message }}</Message>
                </div>
            </div>
        </div>


        <span class="p-float-label">
            <InputText id="name" type="text" v-model="formData.name"/>
            <label for="name">Tag Name</label>
        </span>

        <Button
            type="button"
            :label="$t('Tag add')"
            class="p-button-outlined"
            @click="onClickStore"
            />

    </div>
</template>

<script>
import {
    ref,
    onMounted,
    reactive,
} from 'vue';

import Button from "primevue/button";
import InputText from "primevue/inputtext";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import Message from 'primevue/message';
import { errorToast } from './../../itemListError.js';

export default {
    components: {
        Button,
        InputText,
        Message,
    },
    props: {
        item_id: {
            required: true
        },
    },
    setup(props) {
        const toast = useToast();

        const formData = reactive({
            name: "",
        })
        const errors = ref([]);

        const load = () => {
        }
        onMounted(load);

        const onClickStore = function() {
            const postData = {
                item_id: props.item_id,
                name: formData.name,
            }
            axios.post(
                '/api/item/tag',
                postData,
            ).then(res => {
                formData.name = "";
                errors.value = {};
                location.reload();
            }).catch(error => {
                errorToast(error.response.data, toast);
            })
        }

        return {
            formData,
            errors,
            onClickStore,
        }
    },
}
</script>

